<template>
  <div>
    <base-page-title :titleText="pageTitle" />
    <b-col class="col-12 col-md-8 p-3 mx-auto">
      <b-card no-body class="p-3 mb-2">
        <div class="d-flex align-items-center">
          <img src="./../assets/icons/user.svg" class="icon mr-1" />
          <h6 class="font-weight-bold mb-0">{{ $t("page.settings.title") }}</h6>
        </div>
        <hr />
        <b-form-group
          label-class="font-weight-bold"
          :label="$t('settings.optimization')"
          label-for="optimization"
        >
          <b-form-checkbox
            id="optimization"
            v-model="optimizationEnabled"
            switch
            @change="onToggleOptimization"
          >
            <span class="text-muted ml-3">
              {{ $t("settings.optimizationText") }}
            </span>
          </b-form-checkbox>
        </b-form-group>
        <p class="text-muted body__2 mb-0">
          {{ $t("settings.environmentNote") }}
        </p>
      </b-card>
    </b-col>
  </div>
</template>

<script>
import services from "./../services";

export default {
  data() {
    return {
      pageTitle: "page.settings.title",
      optimizationEnabled: false,
    };
  },
  created() {
    this.loadSettings();
  },
  methods: {
    loadSettings() {
      this.$store.commit("loader/SET_LOADER", {});
      services.SettingsService.getSettings()
        .then(settings => {
          this.optimizationEnabled = !!(settings && settings.optimizationEnabled);
        })
        .catch(() => {
          this.$store.commit("error/SET_ERROR", {});
        })
        .finally(() => this.$store.dispatch("loader/close"));
    },
    onToggleOptimization(value) {
      this.$store.commit("loader/SET_LOADER", {});
      services.SettingsService.updateSettings({ optimizationEnabled: value })
        .then(settings => {
          this.optimizationEnabled = !!(settings && settings.optimizationEnabled);
          this.$store.commit("success/SET_SUCCESS_INFO", {});
        })
        .catch(() => {
          this.optimizationEnabled = !value;
          this.$store.commit("error/SET_ERROR", {});
        })
        .finally(() => this.$store.dispatch("loader/close"));
    },
  },
};
</script>

<style scoped>
.icon {
  width: 20px;
  height: 20px;
  filter: invert(0%) sepia(85%) saturate(7500%) hue-rotate(173deg)
    brightness(87%) contrast(113%);
}
</style>
